const accessAerial = (() => {

  const pageAccess = (document.getElementById("pageAccess") != null);
  if (pageAccess) {


    let aerialWrap = document.querySelectorAll('.aerial-wrap');
    let root = document.querySelectorAll('.aerial-wrap .root');
    let light = document.querySelectorAll('.aerial-wrap .light');
    let txt = document.querySelectorAll('.aerial-wrap .txt');

    gsap.set([light, txt], {
      opacity: 0,
    });

    const aerialTL = gsap.timeline({
      scrollTrigger: {
        trigger: aerialWrap,
        start: "20% 50%",
        // markers: true,
      },
    });

    aerialTL.to(root,{
        clipPath:"polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        duration: 1.6,
      }
    );
    aerialTL.to(light,{
      opacity: 1,
      duration: 0.6,
      eaase: "expo.inOut",
    },">-0.4");
    aerialTL.to(txt,{
      opacity: 1,
      duration: 0.8,
    });





  }

})();
export default accessAerial;